import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import axios from 'utils/axios';
import { creator } from 'uwork-app-core';

/**
 * External Actions
 */

import { actions as workerActions } from 'sagas/app/workers/workersSaga';

/**
 * Constants
 */
export const REQUEST = '@app/workers/giveaccesssaga/REQUEST';
export const SUCCESS = '@app/workers/giveaccesssaga/SUCCESS';
export const FAILURE = '@app/workers/giveaccesssaga/FAILURE';
export const CLEAR = '@app/workers/giveaccesssaga/CLEAR';
export const CLOSE_MODAL = '@app/workers/giveaccesssaga/CLOSE_MODAL';
/**
 * Initial state
 */
const initState = {
    items: []
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case SUCCESS:
                draft.items = payload.data;
                draft.id = payload.data.id;
                break;
            case FAILURE:
                draft.errorStatus = payload;
                break;
            case CLEAR:
                draft.items = [];
                break;
            case CLOSE_MODAL:
                draft.id = null;
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Selectors
 */

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    clear: () => creator(CLEAR),
    close: () => creator(CLOSE_MODAL)
};

/**
 * Sagas
 */
export const sagas = {
    *request({ payload }) {
        try {
            const response = yield axios.put(`/workers/send-password/${payload}`);
            yield put(actions.success(response.data));
            yield put(workerActions.stage_change(response.data.data));
        } catch (e) {
            const error =
                (e.response && e.response.data && e.response.data.message) ||
                'Error: Something went wrong please contact support!';
            yield put(creator(CLEAR));
            yield put(creator(CLOSE_MODAL));
            yield put(actions.failure(error));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
